import { DocumentPageModel } from '@/types';

export const DocumentViewUtils = {
  getFurthestPageFromOtherDocument(
    documentPages: DocumentPageModel[],
    documentId: number
  ): DocumentPageModel | undefined {
    const furthestPage = documentPages
      .filter((p) => p.documentId !== documentId)
      .sort((a: DocumentPageModel, b: DocumentPageModel) => {
        const distance = a.pageNumber - b.pageNumber;
        if (distance) {
          return distance;
        }
        return a.pageNumber - b.pageNumber;
      })
      .reverse()[0];
    return furthestPage;
  },

  getFurthestPage(documentPages: DocumentPageModel[], pageNumber: number): DocumentPageModel | undefined {
    const furthestPage = documentPages
      .slice()
      .sort((a: DocumentPageModel, b: DocumentPageModel) => {
        const distance = Math.abs(a.pageNumber - pageNumber) - Math.abs(b.pageNumber - pageNumber);
        if (distance) {
          return distance;
        }
        return a.pageNumber - b.pageNumber;
      })
      .reverse()[0];
    return furthestPage;
  },

  getNeighboringPageNumbers(totalPages: number, pageNumber: number, neighboringPageCount: number): number[] {
    const pagesToDownload = [] as number[];
    for (let i = 1; i <= neighboringPageCount; i++) {
      const next = pageNumber + i;
      if (next <= totalPages) {
        pagesToDownload.push(next);
      }
      const prev = pageNumber - i;
      if (prev > 0) {
        pagesToDownload.push(prev);
      }
    }
    return pagesToDownload;
  }
};
